<template>

<div>
        <div class="columns is-vcentered is-centered">
            <div class="column is-12-mobile is-4">
                <div :class="{'box has-text-grey back-gold is-clipped':true, 'vip-back vip-ribbon':top3[0].isvip > 0}">

                    <span class="is-pulled-right heart-box">
                        <fa icon="heartbeat" class="has-text-primary heart-beat" v-if="top3[0].is_online" v-tooltip="{ content: 'En Línea' }" />
                        <fa icon="heart-broken" class="has-text-grey" v-tooltip="{ content: 'Desconectado' }" v-else />
                    </span>

                    <div class="media">
                        <div class="media-left">
                            <figure class="image is-64x64">
                                <fa icon="medal" class="gold-color fa-4x" />
                            </figure>
                            <!-- LEVEL AND VIP OPTIONS -->
                            <p class="has-text-centered">
                                <small>Lvl.{{top3[0].clevel}}</small>
                                <br v-if="top3[0].isvip > 0">
                                <small v-if="top3[0].isvip > 0" class="has-text-link"><fa icon="award" class="fa-2x" /></small>
                            </p>
                        </div>
                        <div class="media-content has-text-centered has-text-justified-mobile">
                            <small v-if="top3[0].guild_detail" class="is-size-7 has-text-primary">[ <fa icon="crown" v-if="top3[0].guild_detail.is_master" v-tooltip="{ content: 'Maestro de Gremio' }" /> {{top3[0].guild_detail.guild.name}} ]</small>
                            <p :class="{
                                'is-size-3-widescreen is-size-4-touch is-size-4-desktop is-marginless':true, 
                                'has-text-warning-dark':top3[0].pkcount == 1,
                                'has-text-danger-dark':top3[0].pkcount > 1, 
                                'has-text-link-dark':top3[0].pkcount < -1, 
                                'has-text-info':top3[0].pkcount == -1}">  
                                <b>{{top3[0].name}}</b>
                            </p>
                    <!-- PARTICLE ANIMATION -->
                    <!-- <div class="mc-wrap" v-if="top3[0].isvip > 0">
                        <span class="c" v-for="n in (top3[0].resets+(top3[0].grandresets*10))+1" :key="n"></span>
                    </div> -->

                            <p class="is-size-4 is-size-5-touch has-text-grey is-marginless"><span v-tooltip="{ content: 'Grand Resets' }">GR:{{top3[0].grandresets}}</span> | <span v-tooltip="{ content: 'Resets' }">R:{{top3[0].resets}}</span></p>
                            <small>{{charClass(top3[0].class_field)}}</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-12-mobile is-3" v-if="top3.length > 1">
                <div :class="{'box has-text-grey is-clipped':true, 'vip-back vip-ribbon':top3[1].isvip > 0}">
                    <span class="is-pulled-right heart-box">
                        <fa icon="heartbeat" class="has-text-primary heart-beat" v-if="top3[1].is_online" v-tooltip="{ content: 'En Línea' }" />
                        <fa icon="heart-broken" class="has-text-grey" v-tooltip="{ content: 'Desconectado' }" v-else />
                    </span>
                    <div class="media">
                        <div class="media-left">
                        <figure class="image is-48x48">
                            <fa icon="medal" class="silver-color fa-3x" />
                        </figure>
                        <!-- LEVEL AND VIP OPTIONS -->
                        <p class="has-text-centered">
                            <small>Lvl.{{top3[1].clevel}}</small>
                            <br v-if="top3[1].isvip > 0">
                            <small v-if="top3[1].isvip > 0" class="has-text-link"><fa icon="award" class="fa-2x" /></small>
                        </p>
                        </div>
                        <div class="media-content has-text-centered has-text-justified-mobile">
                            <small v-if="top3[1].guild_detail" class="is-size-7 has-text-primary">[ <fa icon="crown" v-if="top3[1].guild_detail.is_master" v-tooltip="{ content: 'Maestro de Gremio' }" /> {{top3[1].guild_detail.guild.name}} ]</small>
                            <p :class="{
                                'is-size-4-widescreen is-size-4-touch is-size-5-desktop is-marginless':true, 
                                'has-text-warning-dark':top3[1].pkcount == 1,
                                'has-text-danger-dark':top3[1].pkcount > 1, 
                                'has-text-link-dark':top3[1].pkcount < -1, 
                                'has-text-info':top3[1].pkcount == -1}">
                                <b>{{top3[1].name}}</b>
                            </p>

                    <!-- PARTICLE ANIMATION -->
                    <div class="mc-wrap" v-if="top3[1].isvip > 0">
                        <span class="c" v-for="n in (top3[1].resets+(top3[1].grandresets*10))+1" :key="n"></span>
                    </div>

                            <p class="is-size-5 has-text-grey is-marginless"><span v-tooltip="{ content: 'Grand Resets' }">GR:{{top3[1].grandresets}}</span> | <span v-tooltip="{ content: 'Resets' }">R:{{top3[1].resets}}</span></p>
                            <small>{{charClass(top3[1].class_field)}}</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-12-mobile is-3" v-if="top3.length > 2">
                <div :class="{'box has-text-grey is-clipped':true,'vip-back vip-ribbon':top3[2].isvip > 0}">
                    <span class="is-pulled-right heart-box">
                        <fa icon="heartbeat" class="has-text-primary heart-beat" v-if="top3[2].is_online" v-tooltip="{ content: 'En Línea' }" />
                        <fa icon="heart-broken" class="has-text-grey" v-tooltip="{ content: 'Desconectado' }" v-else />
                    </span>
                    <div class="media">
                        <div class="media-left">
                        <figure class="image is-32x32">
                            <fa icon="medal" class="bronze-color fa-2x" />
                        </figure>
                        <!-- LEVEL AND VIP OPTIONS -->
                        <p>
                            <small>Lvl.{{top3[2].clevel}}</small>
                            <br v-if="top3[2].isvip > 0">
                            <small v-if="top3[2].isvip > 0" class="has-text-link"><fa icon="award" class="fa-2x" /></small>
                        </p>
                        </div>
                        <div class="media-content has-text-centered has-text-justified-mobile">
                            <small v-if="top3[2].guild_detail" class="is-size-7 has-text-primary">[ <fa icon="crown" v-if="top3[2].guild_detail.is_master" v-tooltip="{ content: 'Maestro de Gremio' }" /> {{top3[2].guild_detail.guild.name}} ]</small>
                            <p :class="{
                                'is-size-5-widescreen is-size-4-touch is-size-5-desktop is-marginless':true, 
                                'has-text-warning-dark':top3[2].pkcount == 1,
                                'has-text-danger-dark':top3[2].pkcount > 1, 
                                'has-text-link-dark':top3[2].pkcount < -1, 
                                'has-text-info':top3[2].pkcount == -1}">
                                <b>{{top3[2].name}}</b>
                            </p>

                    <!-- PARTICLE ANIMATION -->
                    <div class="mc-wrap" v-if="top3[2].isvip > 0">
                        <span class="c" v-for="n in (top3[2].resets+(top3[2].grandresets*10))+1" :key="n"></span>
                    </div>

                            <p class="is-size-6 is-size-5-touch is-marginless"><span v-tooltip="{ content: 'Grand Resets' }">GR:{{top3[2].grandresets}}</span> | <span v-tooltip="{ content: 'Resets' }">R:{{top3[2].resets}}</span></p>
                            <small>{{charClass(top3[2].class_field)}}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns is-vcentered is-centered" v-if="top10.length > 0">
            <div class="column is-2 is-12-mobile" v-for="(char,n) in top10" :key="n">
                <div :class="{'box is-clipped':true,'vip-back vip-ribbon small':char.isvip > 0}">
                            <span class="is-pulled-right heart-box">
                                <fa icon="heartbeat" class="has-text-primary heart-beat" v-if="char.is_online" v-tooltip="{ content: 'En Línea' }" />
                                <fa icon="heart-broken" class="has-text-grey" v-tooltip="{ content: 'Desconectado' }" v-else />
                            </span>
                    <small v-if="char.guild_detail" class="is-size-7 has-text-primary is-pulled-left">[ <fa icon="crown" v-if="char.guild_detail.is_master" v-tooltip="{ content: 'Maestro de Gremio' }" /> {{char.guild_detail.guild.name}} ]</small>
                    <br v-if="char.guild_detail">
                    <span class="is-pulled-left">{{char.position}}.</span>

                    <!-- PARTICLE ANIMATION -->
                    <div class="mc-wrap" v-if="char.isvip > 0">
                        <span class="c" v-for="n in (char.resets+(char.grandresets*10))+1" :key="n"></span>
                    </div>
                    <p :class="{'has-text-justified-mobile':true}"> 
                        <span :class="{
                            'has-text-warning-dark':char.pkcount == 1,
                            'has-text-danger-dark':char.pkcount > 1, 
                            'has-text-link-dark':char.pkcount < -1, 
                            'has-text-info':char.pkcount == -1}">
                                <b>{{char.name}}</b> 
                        </span>
                        <br> <span v-tooltip="{ content: 'Grand Resets' }">GR:{{char.grandresets}}</span> | <span v-tooltip="{ content: 'Resets' }">R:{{char.resets}}</span>
                        <br><small>Nivel {{char.clevel}}</small>
                        <br><small>{{charClass(char.class_field)}}</small>
                        <br><span v-if="char.isvip > 0" class="has-text-link"><fa icon="award" /></span>
                    </p>
                </div>
            </div>
        </div>
        <div class="card" v-if="top100.length > 0">
            <div class="card-content">
                <div class="table-container">
                    <table class="table is-hoverable is-striped is-fullwidth">
                        <thead>
                            <tr class="has-text-justified">
                            <th>Nro.</th>
                            <th>Nombre</th>
                            <th><abbr title="Grand Resets">G.R.</abbr></th>
                            <th><abbr title="Resets">R.</abbr></th>
                            <th><abbr title="Nivel">Lvl.</abbr></th>
                            <th>Raza</th>
                            <th>Conexión</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(char,n) in top100" :key="n" :class="{'vip-back has-background-link-light':char.isvip>0,'has-text-justified':true}">
                                <td>{{char.position}}</td>
                                <td class="td-name">
                                    <small v-if="char.guild_detail" class="has-text-primary">
                                        [ <fa icon="crown" v-if="char.guild_detail.is_master" v-tooltip="{ content: 'Maestro de Gremio' }" /> {{char.guild_detail.guild.name}} ]&nbsp;
                                    </small>
                                    <!-- NOMBRE -->
                                    <span :class="{
                                        'has-text-warning-dark':char.pkcount == 1,
                                        'has-text-danger-dark':char.pkcount > 1, 
                                        'has-text-link-dark':char.pkcount < -1, 
                                        'has-text-info':char.pkcount == -1
                                    }">
                                        <b>{{char.name}}</b>
                                    </span>
                                    <!-- VIP BADGE -->
                                    <small v-if="char.isvip > 0" class="has-text-link">&nbsp;<fa icon="award" /> VIP</small>
                                </td>
                                <td>{{char.grandresets}}</td>
                                <td>{{char.resets}}</td>
                                <td>{{char.clevel}}</td>
                                <td>{{charClass(char.class_field)}}</td>
                                <td><span class="has-text-primary" v-if="char.is_online">En Línea</span><span v-else class="has-text-grey">Desconectado</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </div>
            </div>    
</div>

</template>

<script>
export default {
    name:'RankingPlayers',
    props: {
        top3: {
            type: Array,
            default: ()=>([])
        },
        top10: {
            type: Array,
            default: ()=>([])
        },
        top100: {
            type: Array,
            default: ()=>([])
        }
    },
    computed: {
        charClass() {
            return this.$store.getters.GetCharacterBreed
        }
    },
}
</script>

<style>
.vip-ribbon {
    position:relative;
}

.vip-ribbon::before {
    position:absolute;
    top:12px;
    right:-42px;
    display: block;
    box-sizing:border-box;
    content:"VIP";
    text-transform:uppercase;
    font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size: 11px;
    text-align:center;
    font-weight: 700;
    color: #fff;


        background: transparent; 
        height:0;
        width:160px;                      

        border:25px solid transparent;
        border-bottom:25px solid rgb(50, 115, 220, .8);
        line-height:23px;
    
    transform: rotate(45deg);
}
.vip-ribbon.small::before {
    font-size: 8px !important;
    border-bottom-width: 15px !important;
    line-height:17px !important;
    top: 15px;
    right: -50px;
}
</style>